module.exports = __webpack_public_path__ + "img/20250827_Laurenz-26.4add75eb.jpg";